import { Outlet, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import Header from './Header';
import { useState } from 'react';
import Sidebar from './Sidebar';
import { Spinner } from '../ui/spinner';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  
  // Determine if we're in admin area based on the current path
  const isAdminArea = location.pathname.startsWith('/admin');
  
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar for mobile - positioned absolutely with overlay */}
      <div 
        className={`fixed inset-0 z-40 bg-background/80 backdrop-blur-sm transition-opacity md:hidden ${
          sidebarOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={() => setSidebarOpen(false)}
      />
      
      {/* Sidebar - fixed on mobile, permanent on desktop */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 transform bg-card transition-transform duration-200 ease-in-out md:relative md:translate-x-0 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <Sidebar isAdmin={isAdminArea} onClose={() => setSidebarOpen(false)} />
      </div>
      
      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header isAdmin={isAdminArea} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {/* Wrap only the page content in Suspense, not the entire layout */}
          <Suspense
            fallback={
              <div className="flex h-full items-center justify-center">
                <Spinner showSpinner />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;